import React from 'react';
import { ToggleButton } from '../ToggleButton';
import { DesignFormMode } from './unitFormModel';

type Props = {
  unitIndex: number;
  selectedMode: DesignFormMode | null;
  setMode: (designFormMode: DesignFormMode) => void;
};

export const DesignFormModeButtons = ({ unitIndex, selectedMode, setMode }: Props) => {
  const options: Array<{ viewType: DesignFormMode; displayText: string }> = [
    { viewType: 'Design', displayText: 'Design' },
    { viewType: 'Map', displayText: 'Map' },
  ];

  return (
    <>
      {options.map(option => (
        <DesignFormModeButton
          key={option.viewType}
          unitIndex={unitIndex}
          mode={option.viewType}
          setMode={setMode}
          selectedMode={selectedMode ?? 'Design'}
        >
          {option.displayText}
        </DesignFormModeButton>
      ))}
    </>
  );
};

type DesignFormModeButtonProps = {
  unitIndex: number;
  mode: DesignFormMode;
  selectedMode: DesignFormMode | null;
  setMode: (designFormMode: DesignFormMode) => void;
  children?: React.ReactNode;
};

const DesignFormModeButton = ({ unitIndex, mode, selectedMode, setMode, children }: DesignFormModeButtonProps) => (
  <ToggleButton
    onClick={() => setMode(mode)}
    $isCurrent={selectedMode === mode}
    data-testid={designFormModeToggleButtonTestId(unitIndex, mode)}
  >
    {children}
  </ToggleButton>
);

export const designFormModeToggleButtonTestId = (unitIndex: number, mode: DesignFormMode) =>
  `unit-${unitIndex}-toggle-creation-view-${mode}`;
